import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { authInterceptor } from './core/auth/interceptors/auth.interceptor';
import { errorInterceptor } from './core/auth/interceptors/error.interceptor';
import { routes } from './app.routes';
import { environment } from '../environments/environment';


registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    // Angular 21 est zoneless par défaut (aucune dépendance zone.js) : la
    // réactivité repose entièrement sur les signals utilisés dans toute
    // l'application (AuthService, ApiService, ConnectivityService...),
    // ce qui est nativement compatible sans configuration supplémentaire.
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    // Le Service Worker gère le cache des assets statiques + des lectures
    // API définies dans ngsw-config.json ; la couche IndexedDB (OfflineDbService)
    // gère en complément le cache métier fin + la file d'écriture hors-ligne.
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.environmentName !== 'LOCAL',
      registrationStrategy: 'registerWhenStable:30000',
    }),

  ],
};
